// libs
import React, { memo } from 'react';

// defs
import { IScrollButtonProps } from './types';

// styles
import { ButtonContainer, ScrollRight, ScrollRightIcon } from './styles';

// hooks
import useTheme from '@nykaa/ui-components/themes/hooks/useTheme';

// icons
import { useStoreIcon, IconName } from 'shared/icons';

const SCROLL_RIGHT_ICON_SIZE = '18px';

function ScrollButton({ scrollButtonType, className = '', onClick }: IScrollButtonProps) {
  const theme = useTheme();
  const ChevronRightIcon = useStoreIcon(IconName.CHEVRON_RIGHT);

  return (
    <ButtonContainer onClick={onClick} buttonType={scrollButtonType} className={className}>
      <ScrollRight>
        <ScrollRightIcon buttonType={scrollButtonType}>
          <ChevronRightIcon size={SCROLL_RIGHT_ICON_SIZE} color={theme.colors.textPrimary} />
        </ScrollRightIcon>
      </ScrollRight>
    </ButtonContainer>
  );
}

export default memo(ScrollButton);
